import {VehicleForm as VFKit} from '../VehicleForm';

interface WltpBasicConsumptionGroupProps {
  suffix: string;
}

export function WltpBasicConsumptionGroup(props: WltpBasicConsumptionGroupProps) {
  return (
    <>
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionWltpCombined"
        suffix={props.suffix}
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionWltpCityCenter"
        suffix={props.suffix}
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionWltpOutskirts"
        suffix={props.suffix}
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionWltpCountryRoads"
        suffix={props.suffix}
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionWltpHighway"
        suffix={props.suffix}
      />
    </>
  );
}
